import api from "./api";

const getDespatcho = async () => {

    const response = await api.get("/api/despatcho");

    return response.data.data;

};

const addDespatcho = async(formData)=>{
    const response = await api.post(
        "/api/despatcho",
        formData
    );

    return response.data;

}

const updateDespatcho = async(id,formData)=>{

    const response = await api.put(
        `/api/despatcho/${id}`,
        formData
    );

    return response.data;

}

const deleteDespatcho = async(id)=>{

    const response = await api.delete(`/api/despatcho/${id}`);

    return response.data;

}

export default{
    getDespatcho,
    addDespatcho,
    updateDespatcho,
    deleteDespatcho
}